import { ReserveVehicleState } from '@/store/reserve-vehicle/state';
import { Mutations } from 'vuex-smart-module';
import {
	ReservedVehicleResponse,
	ReserveTimeLimit,
	DepositAmount,
	Status,
	SubmitErrorMessage,
} from '@/types/reserve-vehicle';

export class ReserveVehicleMutations extends Mutations<ReserveVehicleState> {
	setStatus(type: Status) {
		this.state.status = type;
	}

	unsetStatus() {
		this.state.status = '';
	}

	setLoading() {
		this.state.isLoading = true;
	}

	unsetLoading() {
		this.state.isLoading = false;
	}

	setDisplayWidget() {
		this.state.isDisplayWidget = true;
	}

	unsetDisplayWidget() {
		this.state.isDisplayWidget = false;
	}

	setReservedVehicleResponse(type: ReservedVehicleResponse) {
		this.state.reserveVehicleResponse = type;
	}

	unsetReservedVehicleResponse() {
		this.state.reserveVehicleResponse = null;
	}

	setIsReservedVehicle() {
		this.state.isReserveVehicle = true;
	}

	unsetIsReservedVehicle() {
		this.state.isReserveVehicle = false;
	}

	setReserveTimeLimit(type: ReserveTimeLimit) {
		this.state.reserveTimeLimit = type;
	}

	unsetReserveTimeLimit() {
		this.state.reserveTimeLimit = 0;
	}

	setReserveDepositAmount(type: DepositAmount) {
		this.state.depositAmount = type;
	}

	unsetReserveDepositAmount() {
		this.state.depositAmount = 0;
	}

	setFormError() {
		this.state.isFormError = true;
	}

	unsetFormError() {
		this.state.isFormError = false;
	}

	setSubmitErrorMessage(type: SubmitErrorMessage) {
		this.state.submitErrorMessage = type;
	}

	unsetSubmitErrorMessage() {
		this.state.submitErrorMessage = '';
	}
}
